import React, { useEffect, useState } from "react";
import styles from "./CountDown.module.css";

const Counter = ({
  end,
  duration = 2000,
  showPlus = false,
  description = "",
  styleName = "",
}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const incrementTime = 16; // ~60fps
    const totalSteps = duration / incrementTime;
    const step = end / totalSteps;

    const animate = () => {
      start += step;
      if (start < end) {
        setCount(Math.floor(start));
        requestAnimationFrame(animate);
      } else {
        setCount(end); // final value
      }
    };

    requestAnimationFrame(animate);
  }, [end, duration]);

  return (
    <div className={styles.countContainer}>
      <span className={`${styles.count} ${styles[styleName]}`}>
        {count.toLocaleString()}
        {showPlus ? "+" : ""}
      </span>
      <p>{description}</p>
    </div>
  );
};

export default Counter;
